import { ReactNode } from 'react';
import { P2GBox, P2GFade, P2GIcon, P2GLink, SvgCaretDownBlock, SvgCaretRightBlock } from '@parcel2go/core-ui';
import useLocalStorage from '~/hooks/use-local-storage';
import { FancySelection } from './FancySelection';

const RenderSection = ({
  storageKey,
  title,
  links,
  openAsDefault,
  icon,
  forceOpen
}: {
  storageKey: string;
  title?: string;
  links: ReactNode[];
  icon: ReactNode;
  openAsDefault: boolean;
  forceOpen?: boolean;
}) => {
  const { storedValue, setValue } = useLocalStorage<boolean>(storageKey, openAsDefault);

  if (links.filter((x) => !!x).length === 0) {
    return null;
  }

  return (
    <P2GBox>
      <FancySelection selected={storedValue} onClick={() => setValue(!storedValue)} isMenu>
        <P2GBox display="flex" gap={1}>
          {icon && <P2GIcon palette="primary">{icon}</P2GIcon>}
          <P2GLink underline="none">{title}</P2GLink>
        </P2GBox>
        <P2GIcon size="xs">{storedValue ? <SvgCaretDownBlock /> : <SvgCaretRightBlock />}</P2GIcon>
      </FancySelection>
      <P2GBox ml={4}>
        {(!title || storedValue || forceOpen) && (
          <P2GFade in>
            <P2GBox display="flex" flexDirection="column">
              {links
                .filter((x) => !!x)
                .map((x, index) => (
                  <P2GBox key={index}>{x}</P2GBox>
                ))}
            </P2GBox>
          </P2GFade>
        )}
      </P2GBox>
    </P2GBox>
  );
};

export default RenderSection;
